// Version 0: the collection is new (LAE-768), so it needs no migration strategy.
export default {
  title: 'payment schema',
  version: 0,
  keyCompression: true,
  primaryKey: 'uuid',
  type: 'object',
  required: ['uuid', 'workspaceId', 'proformaInvoiceId', 'amount', 'receivedAt'],
  properties: {
    uuid: {
      type: 'string',
      maxLength: 100,
    },
    workspaceId: {
      type: 'string',
      maxLength: 36,
    },
    proformaInvoiceId: {
      type: 'string',
      maxLength: 100,
    },
    contactId: {
      type: ['string', 'null'],
    },
    amount: {
      type: 'number',
    },
    receivedAt: {
      type: 'number',
    },
    createdAt: {
      type: ['number', 'null'],
    },
    updatedAt: {
      type: ['number', 'null'],
    },
    createdBy: {
      type: ['string', 'null'],
    },
    updatedBy: {
      type: ['string', 'null'],
    },
  },
  indexes: ['workspaceId'],
};
